import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { convertTime } from "../../utils/timeUtils";
import { TimeCell } from "./Kitchen/Report/TimeCell";
import { formatSalesValue } from "../../utils/formatUtils";
import PageStatus from "../PageStatus/PageStatus";
import { useLocation } from "react-router-dom";

const CompletedTodayAdmin = () => {
    const token = localStorage.getItem("token");
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const today = new Date().toLocaleDateString("en-CA");

    const location = useLocation();
    const { outlet } = location.state || {};

    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [expandedRows, setExpandedRows] = useState({});

    const fetchCompletedOrders = useCallback(async () => {
        if (!token || !outlet) return null;

        try {
            setLoading(true);
            setError("");
            setExpandedRows({});

            const response = await axios.post(`${baseUrl}/get-completed`, {
                token,
                outlet_name: outlet,
                start_date: today,
                end_date: today
            });

            setOrders(response.data?.data || []);
        } catch (err) {
            setError(
                err?.response?.data?.error ||
                err?.response?.data?.message ||
                "Failed to fetch completed orders."
            );
            setOrders([]);
        } finally {
            setLoading(false);
        }
    }, [baseUrl, token, outlet]);

    useEffect(() => {
        fetchCompletedOrders();
    }, [fetchCompletedOrders]);

    const toggleRow = (index) => {
        setExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />

            <div className="flex-grow">
                <div className="px-6 py-4 max-w-6xl mx-auto">

                    <PageStatus
                        loading={loading}
                        error={error}
                        loadingText="Loading completed orders..."
                    />

                    {!loading && !error && orders.length === 0 && (
                        <div className="max-w-xl mx-auto mt-10 w-full text-center">
                            <div className="rounded-xl border border-amber-200 bg-amber-50 p-6">
                                <h2 className="text-lg font-semibold text-amber-700">
                                    No Completed Orders Found
                                </h2>

                                <div className="text-base font-medium text-amber-600 mt-1">
                                    There are no completed orders for today.
                                </div>
                            </div>
                        </div>
                    )}

                    {!loading && !error && orders.length > 0 && (
                        <div className="bg-white rounded-xl border border-[#E0DDD8] overflow-hidden">
                            <div className="overflow-auto tiny-scrollbar max-h-[600px]">
                                <table className="w-full text-sm text-center">
                                    <thead>
                                        <tr className="bg-[#F8F7F3] border-b border-[#E0DDD8] text-xs top-0 sticky z-20">
                                            {[
                                                "",
                                                "KOT ID",
                                                "Table",
                                                "Ordered At",
                                                "Completed At",
                                                "Total Time",
                                                "Guests",
                                                "Type",
                                                "State",
                                                "Employee",
                                            ].map((header) => (
                                                <th
                                                    key={header}
                                                    className="
                                                px-2 py-3
                                                font-semibold
                                                text-[#8a8780]
                                                uppercase
                                                tracking-widest
                                                whitespace-nowrap
                                            "
                                                >
                                                    {header}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {orders.map((order, index) => (
                                            <React.Fragment key={index}>
                                                <tr
                                                    className="
                                                border-b border-[#F8F7F3]
                                                hover:bg-[#FAFAF8]
                                                transition-colors font-medium
                                                cursor-pointer
                                            "
                                                    onClick={() => toggleRow(index)}
                                                >
                                                    <td className="px-1 py-2.5">
                                                        <button
                                                            className="
                                                        p-1.5 rounded-md
                                                        hover:bg-[#F3F1EC]
                                                        transition-colors
                                                    "
                                                        >
                                                            {expandedRows[index] ? (
                                                                <HiChevronUp size={18} />
                                                            ) : (
                                                                <HiChevronDown size={18} />
                                                            )}
                                                        </button>
                                                    </td>

                                                    <td className="px-2 py-2.5 text-[#2C2C2A]">
                                                        {order.KOTID}
                                                    </td>

                                                    <td className="px-2 py-2.5 text-[#5a5854]">
                                                        {order.tableNum}
                                                    </td>

                                                    <td className="px-2 py-2.5 text-[#5a5854]">
                                                        {convertTime(order.orderedAt)}
                                                    </td>

                                                    <td className="px-2 py-2.5 text-[#5a5854]">
                                                        {convertTime(order.completedAt)}
                                                    </td>

                                                    <td className="px-2 py-2.5 text-[#5a5854]">
                                                        {order.TotalTime}
                                                    </td>

                                                    <td className="px-2 py-2.5 text-[#5a5854]">
                                                        {order.Guest_count}
                                                    </td>

                                                    <td className="px-2 py-2.5 text-[#5a5854]">
                                                        {order.orderType}
                                                    </td>

                                                    <td className="px-2 py-2.5">
                                                        <span
                                                            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border"
                                                            style={{
                                                                background: "#ECFDF5",
                                                                borderColor: "#BBF7D0",
                                                                color: "#15803D",
                                                            }}
                                                        >
                                                            <span className="w-1.5 h-1.5 rounded-full bg-[#16A34A]" />
                                                            {order.currentState}
                                                        </span>
                                                    </td>

                                                    <td className="px-2 py-2.5 text-[#5a5854]">
                                                        {order.Employee}
                                                    </td>
                                                </tr>

                                                {expandedRows[index] && (
                                                    <tr>
                                                        <td
                                                            colSpan={11}
                                                            className="
                                                        bg-[#FAFAF8]
                                                        border-b border-[#F0EDE8]
                                                        px-4 pb-4
                                                    "
                                                        >
                                                            <table className="w-full text-sm">
                                                                <thead>
                                                                    <tr className="border-b border-[#E0DDD8]">
                                                                        {[
                                                                            "Item",
                                                                            "Ordered At",
                                                                            "Completed At",
                                                                            "Total Time",
                                                                            "Quantity",
                                                                            "Price",
                                                                            "Total",
                                                                        ].map((header) => (
                                                                            <th
                                                                                key={header}
                                                                                className="
                                                                        p-2.5
                                                                        font-semibold
                                                                        text-[#8a8780]
                                                                        uppercase text-xs
                                                                        tracking-wider
                                                                        whitespace-nowrap
                                                                    "
                                                                            >
                                                                                {header}
                                                                            </th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    {order.OrderItemDetailsList?.map(
                                                                        (item, itemIndex) => (
                                                                            <tr
                                                                                key={itemIndex}
                                                                                className="border-b border-[#F0EDE8] font-medium"
                                                                            >
                                                                                <td className="p-2 text-[#2C2C2A]">
                                                                                    {item.ItemName}
                                                                                </td>

                                                                                <td className="p-2 text-[#5a5854]">
                                                                                    {convertTime(item.orderedAt)}
                                                                                </td>

                                                                                <td className="p-2 text-[#5a5854]">
                                                                                    <TimeCell value={item.completedAt} convert />
                                                                                </td>

                                                                                <td className="p-2 text-[#5a5854]">
                                                                                    <TimeCell value={item.TotalTime} />
                                                                                </td>

                                                                                <td className="p-2 text-[#5a5854]">
                                                                                    {item.Quantity}
                                                                                </td>.

                                                                                <td className="p-2 text-[#5a5854]">
                                                                                    {formatSalesValue(item.item_price)}
                                                                                </td>

                                                                                <td className="p-2 text-[#2C2C2A]">
                                                                                    {formatSalesValue(item.Quantity * Number(item.item_price))}
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                </div>
            </div>

            <Footer />
        </div>
    );
};

export default CompletedTodayAdmin;
